import internet from '@devices/settings/device_settings/internet.js';
import actions from '@devices/settings/device_settings/actions.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellysmokenb',
	friendly_name: 'Smoke NB',
	family: 'sensor',
	isPM: false,
	is_nb: true,
	availableViews: ['basic'],
	modes: ['sensor'],
	settings: [
		internet,
		actions,
		share,
		{ title: 'sensor_settings', component: 'not_ready' },
		{
			title: 'settings',
			components: [
				{
					title: 'device_card_customization',
					component: 'customize_device_content',
				},
				{ title: 'firmware_version', component: 'firmware_update' },
				{
					title: 'geo_location_and_time_zone',
					component: 'geo_location_and_time_zone',
				},
				{ title: 'factory_reset', component: 'factory_reset_g1' },
				{ title: 'device_information', component: 'device_information' },
			],
		},
	],
};
